import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";
import { useNavigate } from "react-router-dom";
import { limparCache, recuperarCache, salvarCache, salvarCacheSemCriptografia } from "./cacheHandler";
import NotifyUtils from "../utils/NotifyUtils";
import { useTranslation } from "react-i18next";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const { t } = useTranslation();
    const [user, setUser] = useState(() => {
        // Recupera o usuário do localStorage quando o componente monta
        return recuperarCache('user');
    });
    
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const login = async (email, senha) => {
        try {
            const response = await api.post('/usuariologin_', { email, senha }, {
                headers: {
                    "Content-Type": "application/json",
                },
            })

            if(response.status !== 200) {
                NotifyUtils.erro(t("erro-login"));
            }

            // Se o login for bem sucedido, seta o usuário
            const userLogado = response.data;
            setUser(userLogado);
            salvarCache('user', userLogado);
            salvarCacheSemCriptografia('access_token', userLogado.token);

            setLoading(false);
        } catch (error) {
            if(error.response.status === 403) {
                NotifyUtils.erro(t("erro-usuario-inativo"), {
                    autoClose: 5000
                });
            } else {
                NotifyUtils.erro(t("login-invalido"));
            }
        }
    };

    const logout = () => {
        limparCache('user');
        limparCache('access_token');
        setUser(null);
        navigate('/login', { replace: true });
    };

    const setPodeCadastrarDepartamento = (pode) => {
        let lastUser = user;
        lastUser.podeCadastrarDepartamento = pode;
        setUser(lastUser);
        salvarCache('user', lastUser);
    };

    const setPodeCadastrarUsuario = (pode) => {
        let lastUser = user;
        lastUser.podeCadastrarUsuario = pode;
        setUser(lastUser);
        salvarCache('user', lastUser);
    };

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <AuthContext.Provider value={{ user, login, logout, loading, setPodeCadastrarDepartamento, setPodeCadastrarUsuario }}>
            {children}
        </AuthContext.Provider>
    );
};